if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const selectedSellingPlan = this.getSelectedSellingPlan();
        const selectedSellingPlanVariantId = this.getSelectedSellingPlanVariantId();
        const postAddRedirectUrl = this.getPostAddRedirectUrl(selectedSellingPlan);

        if (selectedSellingPlanVariantId) formData.set('id', selectedSellingPlanVariantId);

        if (selectedSellingPlan) {
          formData.set('selling_plan', selectedSellingPlan);
        } else if (formData.has('selling_plan')) {
          formData.delete('selling_plan');
        }

        if (this.cart && !postAddRedirectUrl) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (postAddRedirectUrl) {
              window.location = postAddRedirectUrl;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.innerHTML = `${window.variantStrings.addToCart}<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.5 8.875V10.75H16.5V8.875C16.5 7.50781 15.3672 6.375 14 6.375C12.5938 6.375 11.5 7.50781 11.5 8.875ZM9.625 12.625H7.125V20.75C7.125 21.8047 7.94531 22.625 9 22.625H19C20.0156 22.625 20.875 21.8047 20.875 20.75V12.625H18.375V14.8125C18.375 15.3594 17.9453 15.75 17.4375 15.75C16.8906 15.75 16.5 15.3594 16.5 14.8125V12.625H11.5V14.8125C11.5 15.3594 11.0703 15.75 10.5625 15.75C10.0156 15.75 9.625 15.3594 9.625 14.8125V12.625ZM9.625 10.75V8.875C9.625 6.49219 11.5781 4.5 14 4.5C16.3828 4.5 18.375 6.49219 18.375 8.875V10.75H20.875C21.8906 10.75 22.75 11.6094 22.75 12.625V20.75C22.75 22.8203 21.0703 24.5 19 24.5H9C6.92969 24.5 5.25 22.8203 5.25 20.75V12.625C5.25 11.6094 6.07031 10.75 7.125 10.75H9.625Z" fill="white"/>
                </svg>`;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      getPostAddRedirectUrl(selectedSellingPlan) {
        if (!this.hasSellingPlanSelectionContext()) return null;

        return selectedSellingPlan ? this.checkoutUrl : window.routes.cart_url;
      }

      getSelectedSellingPlan() {
        const hiddenInput = this.form.querySelector('[data-selected-selling-plan]');
        const hiddenValue = this.normalizeSellingPlanValue(hiddenInput?.value);
        if (hiddenValue) return hiddenValue;

        const selectedInput = this.getSelectedSellingPlanOption();

        return this.normalizeSellingPlanValue(selectedInput?.value);
      }

      getSelectedSellingPlanVariantId() {
        const selectedInput = this.getSelectedSellingPlanOption();

        return selectedInput?.dataset.sellingPlanVariantId || this.variantIdInput.value;
      }

      getSelectedSellingPlanOption() {
        const checkedInputs = this.sellingPlanOptionInputs.filter((input) => input.checked);

        return checkedInputs.find((input) => this.normalizeSellingPlanValue(input.value)) || checkedInputs[0];
      }

      get sellingPlanOptionInputs() {
        return Array.from(document.querySelectorAll('[data-selling-plan-option], [name="selling_plan"]')).filter(
          (input) =>
            input.form === this.form ||
            input.getAttribute('form') === this.form.id ||
            input.closest('[data-product-form-id]')?.dataset.productFormId === this.form.id ||
            input.closest('[data-selling-plan-picker]') ||
            input.closest('.appstle_sub_widget')
        );
      }

      hasSellingPlanSelectionContext() {
        return Boolean(this.form.querySelector('[data-selected-selling-plan]')) || this.sellingPlanOptionInputs.length > 0;
      }

      normalizeSellingPlanValue(value) {
        if (!value) return '';

        return String(value).trim().replace(/^gid:\/\/shopify\/SellingPlan\//, '');
      }

      get checkoutUrl() {
        const root = window.Shopify?.routes?.root || '/';
        return `${root.replace(/\/$/, '')}/checkout`;
      }
    }
  );
}
